<template>
  <div v-cloak @drop.prevent="addDropFiles" @dragover.prevent>
    <v-file-input
      v-bind="$attrs"
      :value="files"
      color="primary"
      dense
      counter
      :counter-size-string="
        `${mess['dialog_base_field_files_label_file']}: {0} (${
          mess['dialog_base_field_files_label__total']
        } {1})`
      "
      multiple
      prepend-icon="mdi-paperclip"
      outlined
      :show-size="1000"
      :key="key"
      @change="$emit('change', $event.length ? [...files, ...$event] : $event)"
    >
      <template v-slot:selection="{ index, text, file }">
        <v-chip
          v-if="index < 20"
          :title="file.name"
          color="primary"
          label
          small
        >
          {{ text }}
          <v-icon @click.stop="removeFile(index)" right color="white" small
            >mdi-close</v-icon
          >
        </v-chip>

        <span v-else-if="index === 2" class="overline mx-2">
          +{{ files.length - 2 }} File(s)
        </span>
      </template>
    </v-file-input>
  </div>
</template>

<script>
export default {
  name: "FileInput",
  inheritAttrs: false,
  model: {
    prop: "files",
    event: "change"
  },
  props: {
    files: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      key: 0
    };
  },
  methods: {
    addDropFiles(e) {
      this.$emit("change", [
        ...this.files,
        ...Array.from(e.dataTransfer.files)
      ]);
    },
    removeFile(index) {
      this.$emit("change", this.files.filter((file, i) => i !== index));
    }
  },
  watch: {
    files() {
      this.key = this.key + 1;
    }
  }
};
</script>

<style>
.v-file-input__text {
  padding-top: 4px;
  cursor: pointer;
}
</style>
